import { render } from "./EnrollmentResultPage.vue?vue&type=template&id=087d6574"
import script from "./EnrollmentResultPage.vue?vue&type=script&lang=js"
export * from "./EnrollmentResultPage.vue?vue&type=script&lang=js"

import "./EnrollmentResultPage.vue?vue&type=style&index=0&id=087d6574&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__